<script setup>
import { ref, watch } from 'vue';
import { useBookingStore } from '@/stores/booking';
import Divider from '~/components/website/common/Divider.vue';
import { getErrorMessage } from '~/helpers/commonUtils';

const props = defineProps({
        isSubmitted: Boolean,
    });

const bookingStore = useBookingStore();

const voucherCode = ref(bookingStore.state?.selected_date);

watch(voucherCode, (value) => {
    bookingStore.updateBookingState({
        voucher_code: value.trim(),
    });
});
</script>

<template>
    <div class="bg-white">
        <!-- form heading -->
        <div class="flex items-center mb-4">
            <p class="font-semibold text-base">Your voucher code</p>
        </div>

        <!-- form -->
        <form class="w-full" @submit.prevent>
            <div key="voucherCode" class="w-full">
                <!-- Input Wrapper -->
                <div
                    :class="[
                            'flex items-center gap-3 px-4 py-3 rounded-full border transition-all',
                            isSubmitted && !voucherCode?.trim()
                                ? 'border-[#CC3D40] error-box-shadow'
                                : 'border-[#A0A2A4]',
                        ]">
                
                    <!-- Input -->
                    <input
                        v-model="voucherCode"
                        type="text"
                        placeholder=""
                        class="w-full bg-transparent outline-none"
                        maxlength="20"
                        required
                    />
                </div>
                
                <!-- Helper Text -->
                <p class="text-sm text-[#888B8D] mt-1">
                    You can find this on your gift voucher
                </p>
                
                <!-- Error -->
                <p
                    v-if="isSubmitted && !voucherCode?.trim()"
                    class="text-[#CC3D40] text-sm mt-1 err-sub-text">
                    {{ getErrorMessage('voucherCode') }}
                </p>
            </div>

            <Divider />
        </form>
    </div>
</template>

<style scoped>
    .error-box-shadow {
        box-shadow: 0 0 0 3px rgba(235, 177, 179, 0.3);
    }
</style>
